<template>
    <div class="mod-menu">
        <el-form :inline="true" :model="dataForm">
            <el-form-item>
                <el-input
                    v-model="dataForm.varName"
                    placeholder="变量名"
                    clearable
                ></el-input>
            </el-form-item>
            <el-form-item>
                <el-button @click="getDataList()">查询</el-button>
                <el-button
                    v-if="isAuth('sys/dic/save')"
                    type="primary"
                    @click="addOrUpdateHandle()"
                    >新增</el-button
                >
            </el-form-item>
        </el-form>
        <el-table :data="dataList" row-key="id" border style="width: 100%">
           <el-table-column type="index" width="50" label="#" align="center"> </el-table-column>
            <el-table-column
                prop="varName"
                header-align="center"
                label="变量名称"
            >
            </el-table-column>
            <el-table-column
                prop="varCode"
                header-align="center"
                align="center"
                label="变量代码"
            >
            </el-table-column>
            <el-table-column
                prop="createTime"
                header-align="center"
                align="center"
                label="创建时间"
            >
            </el-table-column>
            <el-table-column
                prop="updateTime"
                header-align="center"
                align="center"
                label="更新时间"
            >
            </el-table-column>
            <el-table-column
                fixed="right"
                header-align="center"
                align="center"
                label="操作"
            >
                <template slot-scope="scope">
                    <el-button
                        v-if="isAuth('sys/dic/update')"
                        type="text"
                        size="small"
                        @click="addOrUpdateHandle(scope.row.id)"
                    >
                        修改</el-button
                    >
                    <el-button
                        v-if="isAuth('sys/dic/delete')"
                        type="text"
                        size="small"
                        @click="deleteHandle(scope.row.id)"
                        >删除</el-button
                    >
                </template>
            </el-table-column>
        </el-table>
        <!-- 弹窗, 新增 / 修改 -->
        <add-or-update
            v-if="addOrUpdateVisible"
            ref="addOrUpdate"
            @refreshDataList="getDataList"
        ></add-or-update>
    </div>
</template>

<script>
import AddOrUpdate from "./dic-add-or-update";
import { treeDataTranslate } from "@/utils";

export default {
    data() {
        return {
            dataForm: {},
            dataList: [],
            dataListLoading: false,
            addOrUpdateVisible: false,
        };
    },
    components: {
        AddOrUpdate,
    },
    activated() {
        this.getDataList();
    },
    methods: {
        // 获取数据列表
        getDataList() {
            this.dataListLoading = true;
            this.$http({
                url: this.$http.adornUrl("/sys/dic/list"),
                method: "get",
                params: this.$http.adornParams({
                    dicName: this.dataForm.varName,
                }),
            }).then(({ data }) => {
                this.dataList = treeDataTranslate(data.data, "id", "parentId");
                this.dataListLoading = false;
            });
        },
        // 新增 / 修改
        addOrUpdateHandle(id) {
            this.addOrUpdateVisible = true;
            this.$nextTick(() => {
                this.$refs.addOrUpdate.init(id);
            });
        },
        // 删除
        deleteHandle(id) {
            this.$confirm(`确定对[id=${id}]进行[删除]操作?`, "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            })
                .then(() => {
                    this.$http({
                        url: this.$http.adornUrl(`/sys/dic/delete/${id}`),
                        method: "post",
                        data: this.$http.adornData(),
                    }).then(({ data }) => {
                        if (data && data.code === 0) {
                            this.$message({
                                message: "操作成功",
                                type: "success",
                                duration: 1500,
                                onClose: () => {
                                    this.getDataList();
                                },
                            });
                        } else {
                            this.$message.error(data.msg);
                        }
                    });
                })
                .catch(() => {});
        },
    },
};
</script>
